import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Quote from "@/components/landing/Quote";
import Manifesto from "@/components/landing/Manifesto";
import Programme from "@/components/landing/Programme";
import Pioneers from "@/components/landing/Pioneers";
import Details from "@/components/landing/Details";
import Flyer from "@/components/landing/Flyer";
import Inscription from "@/components/landing/Inscription";
import Footer from "@/components/landing/Footer";
import PaymentSuccess from "@/components/landing/PaymentSuccess";
import PaymentCancel from "@/components/landing/PaymentCancel";
import Admin from "@/components/landing/Admin";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App grain bg-cream text-ink">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Quote />
        <Manifesto />
        <Programme />
        <Pioneers />
        <Details />
        <Flyer />
        <Inscription />
      </main>
      <Footer />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
